import { Util } from "@grandvisionhq/forms";
import { useAdyen } from "@grandvisionhq/payments";
import { useIntl } from "@grandvisionhq/state";
const isEmailValid = (email) => email && Util.validations.isEmailAddress(email);
const isPostalCodeValid = (country, postalCode) => country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode);
const useValidatePaymentData = () => {
  const { getLabel } = useIntl();
  const { config } = useAdyen();
  const addressValidations = config?.applepay?.addressValidation;
  return (e, session) => {
    const { shippingContact, billingContact } = e?.payment;
    if (!isEmailValid(shippingContact?.emailAddress)) {
      session.completePayment({
        status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
        errors: [
          new ApplePayError(
            "shippingContactInvalid",
            "emailAddress",
            getLabel("checkout.contact.email.errorMessage")
          )
        ]
      });
      return false;
    }
    if (!isPostalCodeValid(billingContact?.countryCode, billingContact?.postalCode)) {
      session.completePayment({
        status: ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
        errors: [
          new ApplePayError(
            "billingContactInvalid",
            "postalCode",
            getLabel("checkout.address.postalCode.errorMessage")
          )
        ]
      });
      return false;
    }
    if (shippingContact) {
      if (!isPostalCodeValid(shippingContact?.countryCode, shippingContact?.postalCode)) {
        session.completePayment({
          status: ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "postalCode",
              getLabel("checkout.address.postalCode.errorMessage")
            )
          ]
        });
        return false;
      }
      if (addressValidations?.firstName && !addressValidations?.firstName(shippingContact?.givenName || "")) {
        session.completePayment({
          status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "name",
              getLabel("checkout.address.firstName.errorMessage")
            )
          ]
        });
        return false;
      }
      if (addressValidations?.lastName && !addressValidations?.lastName(shippingContact?.familyName || "")) {
        session.completePayment({
          status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
          errors: [
            new ApplePayError(
              "shippingContactInvalid",
              "name",
              getLabel("checkout.address.lastName.errorMessage")
            )
          ]
        });
        return false;
      }
      if (addressValidations?.streetName && shippingContact?.addressLines) {
        const addressLinesValid = shippingContact.addressLines.every(
          (line) => addressValidations?.streetName?.(line)
        );
        if (!addressLinesValid) {
          session.completePayment({
            status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
            errors: [
              new ApplePayError(
                "shippingContactInvalid",
                "addressLines",
                getLabel("checkout.address.streetName.errorMessage")
              )
            ]
          });
          return addressLinesValid;
        }
      }
    }
    if (!billingContact?.locality) {
      session.completePayment({
        status: ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
        errors: [
          new ApplePayError(
            "billingContactInvalid",
            "locality",
            getLabel("checkout.address.city.errorMessage")
          )
        ]
      });
      return false;
    }
    return true;
  };
};
export {
  useValidatePaymentData
};
//# sourceMappingURL=use-validate-payment-data.js.map
